import * as types from './actionTypes'

const initialState = {
  isLoading: true,
}

const businessReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_BUSINESS_INIT:
      return {
        isLoading: true,
        requestedBusinessId: action.businessId,
      }
    case types.FETCH_BUSINESS_SUCCESS:
      if (state.requestedBusinessId != null && String(state.requestedBusinessId) !== String(action.businessId)) return state
      return {
        isLoading: false,
        ...action.data,
        requestedBusinessId: action.businessId,
      }
    case types.FETCH_BUSINESS_FAIL:
      if (state.requestedBusinessId != null && String(state.requestedBusinessId) !== String(action.businessId)) return state
      return {
        ...state,
        isLoading: false,
        loadError: true,
      }
    case types.UPDATE_BUSINESS_COMPANY_INFO:
      return {
        ...state,
        companyInfo: { ...action.companyInfo },
      }
    case types.UPDATE_BUSINESS_NAME:
      if (String(state.businessId) !== String(action.businessId)) return state
      return { ...state, companyInfo: { ...state.companyInfo, companyName: action.name } }
    case types.UPDATE_ACCOUNT_NAME:
      if (String(state.organizationId) !== String(action.organizationId)) return state
      return { ...state, accountName: action.name }
    case types.UPDATE_BUSINESS_KEYWORDS:
      return {
        ...state,
        keywords: action.keywords,
      }
    case types.UPDATE_BUSINESS_BUDGET:
      return {
        ...state,
        businessBudget: action.budget,
      }
    case types.CLEANUP_BUSINESS:
      return initialState
    default:
      return state
  }
}

export default businessReducer
